module.exports = __webpack_public_path__ + "img/nav-crop.0296a9a7.png";